export enum GenericAnalyticsEnum {
  CLICK_HEADER_NAV_ITEM = '[PAC WEB] Header - Clicou no item do header',
  VIEW_FAQ_PAGE = '[PAC WEB] Preciso de Ajuda - Página Visualizada',
  CLICK_FAQ_EMAIL_SAC_BUTTON = '[PAC WEB] Preciso de Ajuda - Paciente - Clicou em "E-mail do SAC"',
  CLICK_FAQ_WHATSAPP_SAC_BUTTON = '[PAC WEB] Precisa de Ajuda - Paciente - Clicou em "WhatsApp do SAC"',
  CLICK_FAQ_SEARCH_BRANCHES_BUTTON = '[PAC WEB] Precisa de Ajuda - Paciente - Clicou em "Encontrar uma unidade física"',
  CLICK_FAQ_SCHEDULE_BUTTON = '[PAC WEB] Precisa de Ajuda - Paciente - Clicou em "Agendar"',
  CLICK_FAQ_MY_ONLINE_SIGN_IN_BUTTON = '[PAC WEB] Preciso de Ajuda - Paciente - Clicou em "Meu cadastro"',
  REDIRECT_FAQ_TO_APPOINTMENT_AFTER_LOGIN = '[PAC WEB] Preciso de Ajuda - Paciente - Redirecionou para a página de agendamentos após login',
  CLICK_FAQ_SEARCH_AVAILABILITY_BUTTON = '[PAC WEB] Preciso de Ajuda - Paciente - Clicou em "Pesquisar disponibilidade"',
  CLICK_FAQ_QUESTION_TOPIC = '[PAC WEB] Preciso de Ajuda - Paciente - Clicou na pergunta',
  CLICK_FAQ_PROFESSIONAL_SAC_EMAIL_BUTTON = '[PAC WEB] Precisa de Ajuda - Parceiro - Clicou em "E-mail do SAC"',
  CLICK_FAQ_WHATSAPP_PARTNER_SAC_BUTTON = '[PAC WEB] Precisa de Ajuda - Parceiro - Clicou em "WhatsApp do SAC"',
  CLICK_FAQ_PROFESSIONAL_BE_OUR_PARTNER = '[PAC WEB] Precisa de Ajuda - Parceiro - Clicou em "Quero atender pela Medprev"',
  CLICK_FAQ_PROFESSIONAL_ACCESS_SYSTEM = '[PAC WEB] Precisa de Ajuda - Parceiro - Clicou em "Entrar no sistema"',

  VIEW_POLICY_PRIVACY_PAGE = '[PAC WEB] Política de privacidade - Página visualizada',
  VIEW_TERMS_USE_PAGE = '[PAC WEB] Termos de uso - Página visualizada',

  VIEW_WORK_WITH_US_PAGE = '[PAC WEB] Trabalhe conosco - Página visualizada',
  CLICK_WORK_WITH_US_SEE_OPPORTUNITY = '[PAC WEB] Trabalhe conosco - Clicou em "Veja nossas oportunidade"',
  CLICK_WORK_WITH_US_BE_OUR_PARTNER = '[PAC WEB] Trabalhe conosco - Clicou em "Seja nosso Parceiro"',
  CLICK_WORK_WITH_US_OPEN_POSITIONS = '[PAC WEB] Trabalhe conosco - Clicou em "Conferir vagas"',

  VIEW_ABOUT_US_PAGE = '[PAC WEB] Sobre nós - Página visualizada',
  CLICK_ABOUT_US_PAGE_SCHEDULE_NOW = '[PAC WEB] Sobre nós - Clicou em "Agendar agora"',
}
